import { Fragment } from 'react';

import type { marked } from 'marked';

import type { RendererFn } from '../type';

export const html: RendererFn<marked.Tokens.HTML> = ({ text }, { key }) => {
  return <Fragment key={key}>{text}</Fragment>;
};
